import { render } from "./mvt-inputgeo.vue?vue&type=template&id=c10b5b78"
import script from "./mvt-inputgeo.js?vue&type=script&lang=js"
export * from "./mvt-inputgeo.js?vue&type=script&lang=js"

import "./mvt-inputgeo.vue?vue&type=style&index=0&id=c10b5b78&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__